import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {XwaysHoarder2} from "../XwaysHoarder2";
import {gsap} from "gsap";
import {XwaysHoarder2Statics} from "../XwaysHoarder2Statics";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {XwaysHoarder2Sound} from "../sound/XwaysHoarder2Sound";
import {SpineGSAPWrapper} from "../utils/SpineGSAPWrapper";
import {XwaysHoarder2GameAssets} from "../XwaysHoarder2GameAssets";


export class FreespinIndicatorView extends PIXI.Container implements StageLayer {

    public currentNumXway: number = 0;
    private lastNumXway: number = 0;
    private currentLevel: number = 0;
    private boxOnReelContainers: PIXI.Container [] = [];
    private bgProgressStr: string = "ui/fsXwaysProgress";
    private litProgressStr: string = "ui/fsXwaysProgressLight";
    private litProgressLastLight = "ui/fsXwaysProgressLight2";
    private spineBars: PIXI.spine.Spine [] = [];
    private spineWrappers: PIXI.Container [] = [];
    private litBoxes: boolean [][] = [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false]
    ];
    private indicatorSlotMap: boolean [][] = [
        [false, false, false],
        [false, false, false],
        [false, false, false],
        [false, false, false]
    ];

    constructor() {
        super();
        this.name = "freespinIndicators";
        this.visible = false;
        this.init();
    }

    public onResize() {
        if (NolimitApplication.isLandscape) {
            this.scale.set(1, 1);
            this.position.set(0, 0);
        } else {
            this.scale.set(0.75, 0.75);
            this.position.set(100, 95);
        }
    }

    public resetAllIndicators(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        this.litBoxes = [
            [false, false, false],
            [false, false, false],
            [false, false, false],
            [false, false, false]
        ];
        tl.add([
            () => {

                this.boxOnReelContainers.forEach((container, bIndex) => {
                    container.children.forEach((dObj) => {
                        if (dObj.name !== "bg" && dObj.name !== "spineBar") {
                            dObj.alpha = 0;
                            dObj.visible = false;
                        }
                    });
                });
            }
        ]);

        this.lastNumXway = 0;
        this.currentNumXway = 0;
        this.currentLevel = 0;

        this.spineBars.forEach((spine) => {
            SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "Idle0Light",false);
            //spine.visible = false;
        });

        return tl;
    }

    public restoreIndicators(): void {
        const currentLit: number [] = XwaysHoarder2.model.data.nextTopBarProgression;
        let currentCountTotal: number = 0;
        currentLit.forEach((val) => {
            currentCountTotal += val;
        });

        XwaysHoarder2.fsIndicators.getXwayIndicatorAnimation(currentCountTotal, false, true);
    }


    getXwayIndicatorAnimation(litIndicatorCount: number, debug: boolean = false, restore: boolean = false): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        const reels: string [][] = XwaysHoarder2.model.data.reels || [];

        if (!debug) {
            let numberOfXways: number = (restore) ? litIndicatorCount : litIndicatorCount - this.lastNumXway;
            let currentIndex: number = (restore) ? 0 : this.lastNumXway; // (numberOfXways > 1)? this.lastNumXway + 1 : this.lastNumXway;
            let newLvlAdded: boolean = false;


            if (currentIndex > -1) {

                if (restore) {
                    while (numberOfXways > 0) {
                        switch (currentIndex) {
                            case 11:
                                this.playIndicatorToLit(3, "light3", 2);
                                if (!newLvlAdded) {
                                    newLvlAdded = true;
                                    this.currentLevel++;
                                }
                                break;
                            case 10:
                                this.playIndicatorToLit(3, "light2", 1);
                                break;

                            case 9:
                                this.playIndicatorToLit(3, "light1", 0);
                                break;

                            case 8:
                                this.playIndicatorToLit(2, "light3", 2);
                                if (!newLvlAdded) {
                                    newLvlAdded = true;
                                    this.currentLevel++;
                                }
                                break;

                            case 7:
                                this.playIndicatorToLit(2, "light2", 1);
                                break;

                            case 6:
                                this.playIndicatorToLit(2, "light1", 0);
                                break;

                            case 5:
                                this.playIndicatorToLit(1, "light3", 2);
                                if (!newLvlAdded) {
                                    newLvlAdded = true;
                                    this.currentLevel++;
                                }
                                break;

                            case 4:
                                this.playIndicatorToLit(1, "light2", 1);
                                break;

                            case 3:
                                this.playIndicatorToLit(1, "light1", 0);
                                break;

                            case 2:
                                this.playIndicatorToLit(0, "light3", 2);
                                if (!newLvlAdded) {
                                    newLvlAdded = true;
                                    this.currentLevel++;
                                }
                                break;
                            case 1:
                                this.playIndicatorToLit(0, "light2", 1);
                                break;
                            case 0:
                                this.playIndicatorToLit(0, "light1", 0);
                                break;

                        }
                        currentIndex++;
                        numberOfXways--;
                    }
                }
            }

            this.lastNumXway = (restore) ? litIndicatorCount : this.currentNumXway;
            this.currentNumXway = litIndicatorCount;
        }
        return tl;
    }

    public show(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if(!this.visible) {
            tl.add(() => {
                this.alpha = 0;
                this.visible = true;
            });
            tl.add(gsap.fromTo(this, {
                duration: 0.1,
                alpha: 0
            }, {
                alpha: 1
            }));
        }

        return tl;
    }

    public hide(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if(this.visible) {
            tl.add(gsap.fromTo(this, {
                duration: 0.1,
                alpha: 1
            }, {
                alpha: 0
            }));
            tl.add(() => {
                this.visible = false;
            });
        }

        return tl;
    }

    public playSpineToLit(boxIndex: number, from: number, to: number, conf: any): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        /*
            {name: 'From 0/0to1', timelines: Array(12), duration: 1.233299970626831}
            {name: 'From 0/0to2', timelines: Array(13), duration: 1.233299970626831}
            {name: 'From 0/0to3', timelines: Array(14), duration: 1.233299970626831}
            {name: 'From 0/Binge-0to3', timelines: Array(14), duration: 1.233299970626831}
            {name: 'From 1/1to2', timelines: Array(13), duration: 1.233299970626831}
            {name: 'From 1/1to3', timelines: Array(14), duration: 1.233299970626831}
            {name: 'From 1/Binge-1to3', timelines: Array(14), duration: 1.233299970626831}
            {name: 'From 2/2to3', timelines: Array(14), duration: 1.233299970626831}
            {name: 'From 2/Binge-2to3', timelines: Array(14), duration: 1.233299970626831}
         */

        //spine.state.setAnimation(0, "From 2/2to3", true);
        let binge: boolean = false;
        let animName: string = "From " + from.toString() + "/" + from.toString() + "to" + to.toString();
        let idleName: string = "Idle" + to + "Light";
        if (boxIndex === 3 && to === 3) {
            animName = "From " + from.toString() + "/Binge-" + from.toString() + "to" + to.toString();
            binge = true;
            idleName = "IdleBinge";
        }

        tl.add([
            () => {
                this.spineBars[boxIndex].visible = true;

                /*
                        L1 = 333ms
                        L2 = 500ms
                        L3 = 666ms
                 */
                const progTl: gsap.core.Timeline = gsap.timeline();
                if(from === 0){
                    switch(to) {
                        case 1:
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                            }, 0);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.66);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                            });
                            break;
                        case 2:
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                            }, 0);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.49);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.65);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                            });
                            break;
                        case 3:
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                            }, 0);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.32);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.49);
                            if(!binge) {
                                progTl.add(() => {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                                }, 0.65);
                            }
                            else {
                                progTl.add(() => {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_BINGE);
                                }, 0.65);
                            }
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                            });
                            break;
                    }
                }
                else if(from === 1) {
                    switch (to) {
                        case 2:
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                            }, 0);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.49);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                            });
                            break;
                        case 3:
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                            }, 0);
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                            }, 0.49);
                            if(!binge) {
                                progTl.add(() => {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                                }, 0.65);
                            }
                            else {
                                progTl.add(() => {
                                    XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_BINGE);
                                }, 0.65);
                            }
                            progTl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                            });
                            break;
                    }
                }
                else if(from === 2) {
                    if(!binge) {
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                        }, 0);
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_LIGHT);
                        }, 0.65);
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                        });
                    }
                    else {
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_UP);
                        }, 0);
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_BINGE);
                        }, 0.65);
                        progTl.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.INDICATOR_SCALE_DOWN);
                        });
                    }
                }
            },
            SpineGSAPWrapper.createTimelineForAnimation(this.spineBars[boxIndex], 0, animName,false)
            //gsap.fromTo(this.spineBars[boxIndex], {duration: 0.3, alpha: 0, ease: "elastic.inOut(1,0.3)"}, {alpha: 1})
        ], "+=0.05");
        tl.add([
            SpineGSAPWrapper.createTimelineForAnimation(this.spineBars[boxIndex], 0, idleName,false)
        ]);
        // this.playIndicatorToLit(0, "light1");
        let count: number = 0;
        switch (boxIndex) {
            case 0:
                count = conf.slot0.nrOfUpdates;
                break;
            case 1:
                count = conf.slot1.nrOfUpdates;
                break;
            case 2:
                count = conf.slot2.nrOfUpdates;
                break;
            case 3:
                count = conf.slot3.nrOfUpdates;
                break;
        }

        const lastIndex: number = (this.litBoxes[boxIndex].lastIndexOf(true) > -1) ? this.litBoxes[boxIndex].lastIndexOf(true) + 1 : 1;
        let x = 0;

        if (lastIndex > -1) {
            while (x < count) {
                tl.add(this.playIndicatorToLit(boxIndex, "light" + (lastIndex + x).toString(), lastIndex + x));
                // console.log("XXX light" + (lastIndex + x).toString());
                x++;
            }
        }


        return tl;
    }

    public calculateUpdatePositions(lastProgressTotal: number, newProgressTotal: number) {
        const returnObj = {
            totalUpdates: 0,
            slot0: {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            },
            slot1: {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            },
            slot2: {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            },
            slot3: {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            },
        }

        // 2 & 7
        const shallUpdateSlot: boolean [] = [false, false, false, false];
        const num = lastProgressTotal;
        if (lastProgressTotal < 3) {
            shallUpdateSlot[0] = true;


            for (let i = num; i < ((newProgressTotal < 3) ? newProgressTotal : 3); i++) {
                returnObj.slot0.nrOfUpdates++;
            }
        }
        if (newProgressTotal > 3) {
            shallUpdateSlot[1] = true;

            for (let i = (lastProgressTotal <= 3) ? 3 : num; i < ((newProgressTotal < 6) ? newProgressTotal : 6); i++) {
                returnObj.slot1.nrOfUpdates++;
            }
        }

        if (newProgressTotal > 6) {
            shallUpdateSlot[2] = true;

            for (let i = (lastProgressTotal <= 6) ? 6 : num; i < ((newProgressTotal < 9) ? newProgressTotal : 9); i++) {
                returnObj.slot2.nrOfUpdates++;
            }
        }
        if (newProgressTotal > 9) {
            shallUpdateSlot[3] = true;

            for (let i = (lastProgressTotal <= 9) ? 9 : num; i < ((newProgressTotal < 12) ? newProgressTotal : 12); i++) {
                returnObj.slot3.nrOfUpdates++;
            }
        }

        /*
            TODO: slot 0 and slot 1 seem to work.
         */

        //const shallUpdateSlot: boolean [] = [false,false,false,false];
        // Count nr of updates for every indicator
        // Slot 0
        if (returnObj.slot0.nrOfUpdates > 0) {
            returnObj.slot0.fromId = lastProgressTotal;
            returnObj.slot0.toId = lastProgressTotal + returnObj.slot0.nrOfUpdates;
            //returnObj.slot0.nrOfUpdates = returnObj.slot0.toId - returnObj.slot0.fromId;

            this.indicatorSlotMap[0].forEach((bool) => {

            });
        } else {
            returnObj.slot0 = {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            };
        }


        // Slot 1
        if (returnObj.slot1.nrOfUpdates > 0) {
            returnObj.totalUpdates = (newProgressTotal - lastProgressTotal);

            returnObj.slot1.fromId = (lastProgressTotal < 3) ? 0 : lastProgressTotal - 3;
            returnObj.slot1.toId = returnObj.slot1.fromId + returnObj.slot1.nrOfUpdates;

            this.indicatorSlotMap[1].forEach((bool) => {

            });
        } else {
            returnObj.slot1 = {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            };
        }

        // Slot 2
        if (returnObj.slot2.nrOfUpdates > 0) {
            returnObj.totalUpdates = (newProgressTotal - lastProgressTotal);

            returnObj.slot2.fromId = (lastProgressTotal < 6) ? 0 : lastProgressTotal - 6;
            returnObj.slot2.toId = returnObj.slot2.fromId + returnObj.slot2.nrOfUpdates;

            this.indicatorSlotMap[2].forEach((bool) => {

            });
        } else {

            returnObj.slot2 = {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            };
        }

        // Slot 3
        if (returnObj.slot3.nrOfUpdates > 0) {
            returnObj.totalUpdates = (newProgressTotal - lastProgressTotal);

            returnObj.slot3.fromId = (lastProgressTotal < 9) ? 0 : lastProgressTotal - 9;
            returnObj.slot3.toId = returnObj.slot3.fromId + returnObj.slot3.nrOfUpdates;

            this.indicatorSlotMap[3].forEach((bool) => {

            });
        } else {

            returnObj.slot3 = {
                nrOfUpdates: 0,
                fromId: -1,
                toId: -1
            };
        }

        // console.log("indicator update position obj", returnObj);
        return returnObj;
    }

    private init(): void {
        this.createLayout();
        this.spineBars.forEach((spine) => {
            SpineGSAPWrapper.createTimelineForAnimation(spine, 0, "Idle0Light",false);
            //spine.visible = false;
        });
        this.onResize();
    }

    private createLayout(): void {
        this.createIndicatorsOnReels();
    }

    private createIndicatorsOnReels(): void {
        const xStart: number = 18;
        const wrappers: PIXI.Container [] = [
            this.createBoRContainers(), this.createBoRContainers(),
            this.createBoRContainers(), this.createBoRContainers(true)
        ];

        this.spineWrappers = [
            new PIXI.Container(), new PIXI.Container(), new PIXI.Container(), new PIXI.Container()
        ];


        wrappers.forEach((container, index) => {
            container.x = xStart + (XwaysHoarder2Statics.symbolWidth * index);
            this.addChild(container);
        });

        this.boxOnReelContainers = wrappers;
        //let startId: number = wrappers[index].children.length
        // TODO: need to put spines in containers above the box containers

        ["spineBar", "spineBar", "spineBar", "spineBar"].forEach((name, index) => {
            const spine: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.FS_PROGRESS));
            spine.name = name;
            spine.x = 110.5;
            spine.y = 50;
            spine.visible = false;
             //console.log("Indicator spines", spine.spineData.animations);
            this.spineWrappers[index].x = this.boxOnReelContainers[index].x;
            this.spineWrappers[index].y = this.boxOnReelContainers[index].y;
            this.spineWrappers[index].addChild(spine);
            this.spineBars.push(spine);
            //spine.state.setAnimation(0, "From 0/Binge-0to3", true);

            this.addChild(this.spineWrappers[index]);
        });


    }

    private createBoRContainers(last: boolean = false, debugSpine: boolean = true): PIXI.Container {
        const box: PIXI.Container = new PIXI.Container();
        const bg: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures(this.bgProgressStr)[0]);
        bg.name = "bg";
        box.addChild(bg);

        const lightYStart: number = -10;
        const lightXStart: number = 22;

        ["light1", "light2", "light3"].forEach((val, index) => {
            const sprite: PIXI.Sprite = new PIXI.Sprite(XwaysHoarder2.assetLoader.getTextures((last && index === 2) ? this.litProgressLastLight : this.litProgressStr)[0]);
            sprite.name = val;
            sprite.x = lightXStart + (index * 44);
            sprite.y = lightYStart;
            sprite.visible = false;
            sprite.alpha = 0;
            box.addChild(sprite);
        });

        return box;
    }

    private playIndicatorToLit(boxIndex: number, lightStr: string, lightIndex: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (this.boxOnReelContainers.length < 1) {
            return tl;
        }

        tl.add([
            () => {
                if (this.boxOnReelContainers[boxIndex].getChildByName(lightStr)) {
                    this.boxOnReelContainers[boxIndex].getChildByName(lightStr).visible = true;
                    this.boxOnReelContainers[boxIndex].getChildByName(lightStr).alpha = 1;
                }
            },
            //gsap.fromTo(this.boxOnReelContainers[boxIndex].getChildByName(lightStr), {duration: 0.3, alpha: 0, ease: "elastic.inOut(1,0.3)"}, {alpha: 1})
        ]);

        this.litBoxes[boxIndex][lightIndex] = true;

        return tl;
    }
}